import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Checkbox} from '@tickchak/react-share/app';
import * as css from './ManagePromotion.css';
import {approvePromotion} from '../../redux/event/eventActions';

interface PromotionPopupContentProps {
    pmid: number;
}

function PromotionPopupContent({pmid}: PromotionPopupContentProps) {
    const {t} = useTranslation('promotionMessage');
    const termsApproved = useSelector((state: any) => state.event.promotionMessage?.termsApproved);

    const handleTermsApproved = (value: number) => {
        approvePromotion(pmid, value).then();
    };

    return (
        <>
            <css.title>{t('popupMessageTitle')}</css.title>
            <css.text>{t('popupMessageText')}</css.text>
            <css.checkboxRow data-cy="promotion-terms-row">
                <Checkbox
                    checked={termsApproved === 1}
                    onChange={(e) => handleTermsApproved(e.target.checked ? 1 : -1)}
                    data-cy="promotion-terms-checkbox"
                />
                {t('termsApproved')}
            </css.checkboxRow>
            <css.contact>{t('contactDetails')}</css.contact>
        </>
    );
}

export default PromotionPopupContent;
